// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3D4NK","approved":"Status_approved__1sDLf","rejected":"Status_rejected__2mFaT","expired":"Status_expired__AsW4S","label":"Status_label__KOJzD"};